export const API_EXTERNAL_ENDPOINT = 'owner-campaign'

export const API_INTERNAL_ENDPOINT = 'strapi/owner-campaign'
